<template>
    <div class="qrcode" ref="qrCodeUrl">
    </div>
</template>

<script>
import QRCode from "qrcodejs2"
export default {
    name: 'fkcode',
    props: {
        link: String,
    },
    watch: {
    },
    data() {
        return {
        }
    },
    created() {
        this.creatQrCode()
    },
    methods: {
        creatQrCode() {
            let that=this;
                this.$nextTick(() => { 
                var qrcode = new QRCode(that.$refs.qrCodeUrl, {
                text: that.link, // 需要转换为二维码的内容
                width: 120,
                height: 120,
                colorDark: '#000000',
                colorLight: '#ffffff'
            })
            })
        },
    },
    mounted() {
    },

}
</script>
<style scoped>
</style>
